import {
  ComponentFactoryResolver,
  Inject,
  Injectable,
  ViewContainerRef,
  ViewRef
} from '@angular/core';
import { ToastComponent, ToastType } from './toast.component';
import { ToastModule } from './toast.module';

const DEFAULT_DURATION = 5000;

@Injectable({
  providedIn: ToastModule
})
export class ToastService {
  constructor(
    @Inject(ComponentFactoryResolver)
    private factoryResolver: ComponentFactoryResolver
  ) {}

  private viewContainerRef: ViewContainerRef = null;

  setViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.viewContainerRef = viewContainerRef;
  }

  private lastViewRef: ViewRef;

  show(
    type: ToastType,
    message: string,
    dismissible: boolean = true,
    duration = DEFAULT_DURATION,
    translateParams?: Record<string, unknown>
  ) {
    if (!this.viewContainerRef) {
      console.warn(
        'ToastService: ViewContainerRef not set; call setViewContainerRef from a component constructor.'
      );
      return;
    }
    if (this.lastViewRef) this.lastViewRef.destroy();
    const factory = this.factoryResolver.resolveComponentFactory(
      ToastComponent
    );
    const component = factory.create(this.viewContainerRef.parentInjector);
    const toastComponent = <ToastComponent>component.instance;
    toastComponent.config = { type, message, dismissible, translateParams };
    const viewRef = this.viewContainerRef.insert(component.hostView);
    setTimeout(() => {
      viewRef.destroy();
    }, duration);
    toastComponent.destroy.subscribe(() => viewRef.destroy());
    this.lastViewRef = viewRef;
  }
}

export interface ToastPayload {
  message: string;
  duration?: number;
}
